import { BrowserRouter, Routes, Navigate, Route } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import PrivateRoute from "./PrivateRoute/PrivateRoute"
import PublicRoute from "./PublicRoute/PublicRoute"
import LangProvider from "../Providers/LangProvider/LangProvider"
import { useUpdateEffect, useWindowSize } from "@piximind/custom-hook"
import { RootState } from "../Interfaces/Redux"
import { setScreen } from "../Redux/Reducers"
import { ForgetPass, Login, PageTest, Register, ResetPass } from "../Pages"
import ModalProvider from "../Providers/ModalProvider/ModalProvider"

const AppRoute = (): JSX.Element => {
  const auth = useSelector((state: RootState) => state?.auth)
  const { width, height } = useWindowSize()
  const dispatch = useDispatch()
  useUpdateEffect(() => {
    dispatch(setScreen({ width, height }))
  }, [width, height])
  function PrivateRouteRender(props: any) {
    return auth?.accessToken === null && auth?.refreshToken === null && auth?.user === null ? (
      <Navigate to="/login" />
    ) : (
      props.children
    )
  }
  function PublicRouteRender(props: any) {
    return !auth?.accessToken && !auth?.refreshToken && !auth?.user ? (
      props.children
    ) : (
      <Navigate to="/" />
    )
  }
  return (
    <LangProvider>
      <ModalProvider />
      <BrowserRouter>
        <Routes>
          <Route
            element={
              <PublicRouteRender>
                <PublicRoute />
              </PublicRouteRender>
            }
          >
            <Route path="/" element={<PageTest />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgetPass" element={<ForgetPass />} />
            <Route path="/resetPass" element={<ResetPass />} />
          </Route>

          <Route
            element={
              <PrivateRouteRender>
                <PrivateRoute />
              </PrivateRouteRender>
            }
          >
            <Route path="/hii" element={<Login />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </LangProvider>
  )
}

export default AppRoute
